import { render, staticRenderFns } from "./AlertWidgetSettingsContent.vue?vue&type=template&id=81c84a38"
import script from "./AlertWidgetSettingsContent.vue?vue&type=script&lang=js"
export * from "./AlertWidgetSettingsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports